{
  "WiiXyO": "Ansvariga användare",
  "eLSbu2": "Skapad av",
  "3fFH+E": "Tilldelade avdelningar",
  "huSfxz": "Skapad",
  "qxeHH9": "Vid frågor eller problem",
  "7kOqOx": "Klicka på: Butiksadmin > Skärmar > Lägg till.",
  "N8l4Rz": "Öppna StoreSprint i mobil / surfplatta.",
  "y22T1i": "Ladda ner StoreSprint från App Store eller Google Play.",
  "+o364m": "Den digitala styrtavlan i framtidens butiker",
  "/mnQNe": "Du måste ha ett adminkonto för att kunna göra detta.",
  "3M57jb": "Välkommen till StoreSprint!",
  "MzrrHV": "Kom igång med butikstavlor, en naturlig plats för möten och ett smidigt sätt att sprida viktig information på!",
  "XmSi2z": "Avvikelse",
  "+28euy": "Ge mig ett namn!",
  "Qqg9/k": "Välj ett passande namn till skärmen.",
  "RWJ3bh": "Vilken tavla ska visas på “{screenName}”?",
  "VY9iji": "Nu kan tavlor kopplas till den här skärmen!",
  "r0IMo4": "Jag heter {screenName}",
  "YQ5gOU": "Ta en extra titt på skärmen så att alla inställningar är korrekta.",
  "ujlMWO": "Time",
  "ImFT7H": "Tidzon",
  "xAxvmA": "Språk",
  "8ZqZIG": "Upplösning",
  "SzDLWp": "Webbläsarversion",
  "4h+k3N": "Engelska",
  "mPpN5+": "Svenska",
  "lqVRx/": "Norska",
  "5GBz70": "Ansvariga avdelningar",
  "YFanI0": "Taggar",
  "TOfbS/": "Avvikelse",
  "0KUtBO": "Slutförd på",
  "4IjTZQ": "Alla avdelningar",
  "9SEYgN": "Avdelningar",
  "Bpx498": "Prio",
  "ECevKX": "Deadline",
  "JTDup4": "Taggar",
  "ODKho5": "slutförde",
  "UCfNSe": "Ansvariga",
  "WvuPXi": "Avvikelse",
  "dHuruW": "Aktivitet",
  "pZMRGW": "Akut",
  "xu5sb3": "Normal",
  "yr+UdN": "skapad",
  "zUIE28": "Hög",
  "NFEWMC": "Avvikelse",
  "hs7FDL": "Ansvariga",
  "ZHEE8s": "Ansvariga",
  "NJ0bCT": "Underuppgifter",
  "o+VywC": "Anställda",
  "sg7pjn": "Nästa signal {current}/{total}",
}
